var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldTruckFast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 16v1c0 1.66-1.34 3-3 3 0-1.65-1.35-3-3-3s-3 1.35-3 3h-2c0-1.65-1.35-3-3-3s-3 1.35-3 3c-1.66 0-3-1.34-3-3v-2c0-.55.45-1 1-1h9.5a2.5 2.5 0 0 0 2.5-2.5V6c0-.55.45-1 1-1h.84c.72 0 1.38.39 1.74 1.01l.64 1.12c.09.16-.03.37-.22.37a2.5 2.5 0 0 0-2.5 2.5v3a2.5 2.5 0 0 0 2.5 2.5h2.5c.28 0 .5.22.5.5z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 22a2 2 0 1 1 0-4 2 2 0 0 1 0 4zM16 22a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 14h-3c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1h1.29l1.45 2.54c.17.3.26.64.26.99V14z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.69 2a3.69 3.69 0 0 0-3.62 2.98h4.37c.38 0 .68.31.68.69 0 .38-.3.68-.68.68H2v1.38h2.6c.38 0 .69.31.69.69 0 .38-.31.68-.69.68H2v1.38h.77c.38 0 .69.31.69.69 0 .38-.31.68-.69.68H2v.23c0 .55.45 1 1 1h9.15c1.02 0 1.85-.83 1.85-1.85V2.92c0-.51-.41-.92-.92-.92H5.69zM1.92 4.98H.94c-.38 0-.69.31-.69.69 0 .38.31.68.69.68H2v-.66c0-.24.03-.48.07-.71h-.15zM.94 7.73c-.38 0-.69.31-.69.69 0 .38.31.68.69.68H2V7.73H.94zM.94 10.48c-.38 0-.69.31-.69.69 0 .38.31.68.69.68H2v-1.37H.94z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldTruckFast);
export default __webpack_public_path__ + "static/media/vuesax-bold-truck-fast.5107d41e85dad2c933b903ab5d6bebb0.svg";
export { ForwardRef as ReactComponent };